const QS_LEVELS = new Array(10).fill().map((_, i) => 'qs' + (i + 1))
const QS_LEVELS_GRADE = ['qssa', 'qssb', 'qssc', 'qssd', 'qsse', 'qssf', 'qssg']
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  QS_CODES: ['qs', 'qst', 'qsj', 'qsn', ...QS_LEVELS, ...QS_LEVELS_GRADE], // Hardcode QS, QS Top, QS Junior, QS Nocheck, QS Level 1-10
  QA_CODES: ['qa', 'qat', 'qaj'], // Hardcode QA, QA Top, QA Junior
  TRAINER_CODES: ['trj', 'tr'], // Hardcode Trainer Junior, Trainer
  MANAGER_CODES: ['mgr'], // Hardcode Manager
}
